import { Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Checkbox, TextField, Select, MenuItem, Box, Typography, Autocomplete, InputLabel, Grid, Skeleton, InputAdornment, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from "react-router-dom";
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import { toast } from 'react-toastify';

import Inventory from "../../models/inventory";
import Products from "../../collections/products";

const UpdateInventoryLevelTransactions = (props) => {
    const { id } = useParams();
    const [inventoryLevelTransactions, setInventoryLevelTransactions] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [quantity, setQuantity] = useState("");
    const [products, setProducts] = useState([]);

    useEffect(() => {
        props.setPageTitle("Cập nhật đơn nhập hàng");

        const fetchData = async () => {
            const inventory = new Inventory();
            const data = await inventory.getInventoryLevelTransactionsById(id);
            setInventoryLevelTransactions(data);
            setQuantity(data.quantity);

            const listProducts = new Products();
            await listProducts.fetch();
            setProducts(listProducts.items);

            const matchedProduct = listProducts.items.find(
                (product) => product.id === data.product_id
            );
            setSelectedProduct(matchedProduct || null);
        }

        fetchData();
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const selectedProductId = selectedProduct.id;

        if (!selectedProduct) {
            toast.error("Vui lòng chọn sản phẩm!",{
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            return;
        }

        if (!quantity || isNaN(quantity) || quantity < 0) {
            toast.error("Vui lòng nhập số lượng hợp lệ!",{
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            return;
        }

        const inventoryLevelTransaction = new Inventory({
            product_id: selectedProductId,
            quantity: quantity,
            transaction_type: 'addition',
        });

        try {
            const res = await inventoryLevelTransaction.updateInventoryLevelTransactionsById(id);
            if (res.success) {
                toast.success(res.messenge, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
            else {
                toast.error(res.messenge, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        }
        catch (error) {
            let errorMessage = "Đã xảy ra lỗi không xác định!";
            if (error.response?.data?.error) {
                if (Array.isArray(error.response.data.error)) {
                    errorMessage = error.response.data.error.join(", ");
                } else if (typeof error.response.data.error === "string") {
                    errorMessage = error.response.data.error;
                } else if (typeof error.response.data.error === "object") {
                    errorMessage = JSON.stringify(error.response.data.error);
                }
            }
            toast.error(errorMessage, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }
    return (
        <Container>
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
                <Grid container spacing={3}>
                    {/* Autocomplete cho sản phẩm */}
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            value={selectedProduct}
                            options={products}
                            getOptionLabel={(option) => option.name}
                            onChange={(event, value) => setSelectedProduct(value)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Chọn sản phẩm"
                                    variant="outlined"
                                    required
                                />
                            )}
                        />
                    </Grid>
                    {/* Trường số lượng */}
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Nhập số lượng"
                            type="number"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                            variant="outlined"
                            fullWidth
                            required
                        />
                    </Grid>
                    {/* Nút lưu */}
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            type="submit"
                        >
                            Lưu thay đổi
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
}

export default UpdateInventoryLevelTransactions;